import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

import Modal from 'components/Modal';

import PDFIcon from 'assets/images/pdf.svg';
import InvoiceIcon from 'assets/images/invoice_icon.svg';

export const SUPPORTED_MEDIA_TYPES = ['Image', 'Video', 'PDF'];

const TYPES_SUPPORT_MODAL = ['Image', 'Video'];

const MediaWithPopup = ({ url, title, type = 'Image', opensToModal = true, width = '50px', height ='50px', isInvoice = false }) => {
    const [modalOpen, setModalOpen] = useState(false);

    if (!TYPES_SUPPORT_MODAL.includes(type)) {
        opensToModal = false;
    }

    const aProps = {
        opensToModal : {
            onClick: () => {
                setModalOpen(true);
                return false;
            },
        },
        openToNewTab: {
            target:'_blank',
            rel:'noreferrer',
            href: url,
        },
    };

    let thumbnailElem;

    switch(type) {
        case 'Image': {
            thumbnailElem = <img width={width} height={height} src={isInvoice ? InvoiceIcon : url} style={{
                objectFit: 'contain',
            }} />;
            break;
        }
        case 'Video': {
            thumbnailElem = <PlayCircleIcon fontSize='large' sx={{ width, height }} />;
            break;
        }
        case 'PDF': {
            thumbnailElem = (
                <Box style={{ position: 'relative' }}>
                    <img width={width} height={height} src={isInvoice ? InvoiceIcon : PDFIcon} />
                    <a href={url} target='_blank' rel='noreferrer' style={{
                        display: 'flex',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                    }}></a>
                </Box>
            );
            break;
        }
    }

    let mediaElem;

    switch (type) {
        case 'Image':{
            mediaElem = <img
                style={{
                    width: title ? '80%' : '80%',
                    maxHeight: '900px',
                    objectFit: 'contain',
                    backgroundSize: 'contain',
                }}
                src={url}
            />;
            break;
        }
        case 'Video':{
            mediaElem = <video
                style={{
                    width: title ? '80%' : '80%',
                    maxHeight: '900px',
                }}
                src={url}
                controls
            />;
            break;
        }
        case 'PDF':{
            mediaElem = null;
            break;
        }
        default:
            mediaElem = null;
    }

    const modalElem = !modalOpen ? null : (
        <Modal
            open={modalOpen}
            title={(title ?? '').toLocaleUpperCase()}
            onClose={() => setModalOpen(false)}
            fullScreen
        >
            <Box width='100%' display='flex' justifyContent='center' pt={title ? 0 : 3}>
                <Box
                    width='90%'
                    display='flex'
                    justifyContent='center'
                    alignItems='center'
                    p={3}
                    pt={title ? 0 : 3}
                >
                    {mediaElem}
                </Box>
            </Box>
        </Modal>
    );

    return (
        <>
            {modalElem}
            <a {...(opensToModal ? aProps.opensToModal : aProps.openToNewTab)} style={{ cursor: 'pointer', display: 'contents' }}>
                {thumbnailElem}
            </a>
        </>
    );
};

MediaWithPopup.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    type: PropTypes.oneOf(SUPPORTED_MEDIA_TYPES),
    opensToModal: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string,
    isInvoice: PropTypes.bool,
};

export default MediaWithPopup;
